import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { ESvgIcons } from '../../../core/enums/svg-icons';

export interface IAttractionInfoDialog {
  title: string;
  description: string;
  imageUrl: string;
}

@Component({
    selector: 'app-attraction-info-dialog',
    templateUrl: './attraction-info.component.html',
    styleUrls: [
        '../../../../styles/dialogs.scss',
        './attraction-info.component.scss',
    ],
    imports: [MatIconModule, TranslateModule, SafeHtmlPipe]
})
export class AttractionInfoComponent {
  public readonly eSvgIcons = ESvgIcons;

  constructor(
    public dialogRef: MatDialogRef<AttractionInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAttractionInfoDialog,
  ) {}

  closeModal(closeResult: boolean): void {
    this.dialogRef.close(closeResult);
  }
}
